









































import Vue from 'vue'
import RouteAssistant from '@/helpers/route-assistant'

export default Vue.extend({
  name: 'ProjectListingKanbanToggle',

  props: {
    isKanban: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      RouteAssistant,
    }
  },
})
